import React from 'react';
import PropTypes from 'prop-types';
import { SFEntityID, SFNotification } from 'utils/types';
import css from 'serviceCatalog/appointments/review/Review.css';
import Time from 'serviceCatalog/appointments/review/Time';
import Location from 'serviceCatalog/appointments/review/Location';
import Reason from 'serviceCatalog/appointments/review/Reason';
import Details from 'serviceCatalog/appointments/review/Details';
import Course from 'serviceCatalog/appointments/review/Course';
import MeetingInstructions from 'serviceCatalog/appointments/review/MeetingInstructions';
import CancelModal from 'upcoming/CancelModal';
import { isEmpty } from 'lodash';
import GroupSessionParticipants from "../../../serviceCatalog/appointments/review/GroupSessionParticipants";

export default class Main extends React.Component {

  constructor() {
    super();
    this.state = { isConfirmDialogOpen: false };
  }

  onCancelAppointmentClicked() {
    this.setState({isConfirmDialogOpen: true});
  }

  closeModal() {
    this.setState({isConfirmDialogOpen: false});
  }

  get cancelModal() {
    // Re-mounts to regenerate state
    return this.state.isConfirmDialogOpen
      ? <CancelModal
          appointmentId={this.props.appointmentId}
          ownerName={this.props.ownerName}
          startDate={this.props.startDate}
          recurring={this.props.recurring}
          notification={this.props.notification}
          open={this.state.isConfirmDialogOpen}
          onClose={this.closeModal.bind(this)}
          onSuccess={() => {
            window.location.href = "#"; // Redirect to upcoming home
            this.props.notification.success("Appointment successfully canceled");
          }}
        />
      : null;
  }

  get course() {
    // If there is no course and you can't change, just don't display this section
    if ( isEmpty(this.props.courseName) && !this.props.canChangeCourse ) return null;
    return (
      <Course
        courseName={this.props.courseName}
        canChangeCourse={this.props.canChangeCourse}
        onAddCourseClicked={this.props.onChangeCourseClicked}
        clearable={this.props.isCourseClearable}
        onClearCourseClicked={this.props.onClearCourseClicked}
      />
    );
  }

  get meetingInstructions() {
    if(!this.props.scheduleBlockInstructions) return null;
    return  (
      <MeetingInstructions instructions={this.props.scheduleBlockInstructions}/>
    );
  }

  render() {
    return (
      <div className={css['content']}>
        <div>
          You must cancel and reschedule this appointment to change the reason, date/time, or person.
          {' '}
          <span
            className={css['link']}
            onClick={() => this.setState({isConfirmDialogOpen: true})}>
            Cancel this appointment
          </span>
        </div>
        <div className={css['container']}>
          <div>
            <Time
              startDate={this.props.startDate}
              duration={this.props.duration}
              recurring={this.props.recurring}
              canChangeDuration={this.props.canChangeDuration}
              onChangeDurationClicked={this.props.onChangeDurationClicked}
            />
            <Location
              canChangeLocation={this.props.canChangeLocation}
              locationName={this.props.locationName}
              locationId={this.props.locationId}
              locations={this.props.locations}
              instructions={this.props.instructions}
              onLocationSelected={this.props.onLocationSelected}
            />
            <GroupSessionParticipants participants={this.props.participants} />
            {this.meetingInstructions}
          </div>
          <div>
            <Reason name={this.props.reasonName} />
            {this.course}
            <Details value={this.props.details} onChange={this.props.onDetailsChanged} />
          </div>
        </div>
        {this.cancelModal}
      </div>
    );
  }
}

Main.propTypes = {
  appointmentId: SFEntityID.isRequired,
  startDate: PropTypes.object.isRequired,
  duration: PropTypes.number.isRequired,
  locations: PropTypes.array.isRequired,
  locationId: SFEntityID.isRequired,
  locationName: PropTypes.string.isRequired,
  ownerName: PropTypes.string.isRequired,
  instructions: PropTypes.string,
  reasonName: PropTypes.string.isRequired,
  recurring: PropTypes.bool,
  courseName: PropTypes.string,
  details: PropTypes.string.isRequired,
  onDetailsChanged: PropTypes.func.isRequired,
  canChangeDuration: PropTypes.bool,
  canChangeLocation: PropTypes.bool,
  canChangeCourse: PropTypes.bool,
  onChangeDurationClicked: PropTypes.func.isRequired,
  onChangeCourseClicked: PropTypes.func.isRequired,
  onLocationSelected: PropTypes.func.isRequired,
  notification: SFNotification.isRequired,
  isCourseClearable: PropTypes.bool,
  onClearCourseClicked: PropTypes.func.isRequired,
  scheduleBlockInstructions: PropTypes.string,
  participants: PropTypes.array
};
